import { ReactNode } from "react";
import { cn } from "@/core/helpers/cn";

type Props = {
  children: ReactNode;
  className?: string;
};

export default function InventoryHeader({ children, className }: Props) {
  return (
    <div className={cn("shrink-0 px-7.5 flex items-center justify-between", className)}>
      {children}
    </div>
  );
}
